import { toQueryString } from "./WebUtils";

const DEBUG = false;

export const ENDPOINT_PATHS = {
    monitoring: "monitoring",
};

export const ENDPOINTS = {
    getMediaSummary: "getMediaSummary",
    getAllSourcesSummary: "getAllSourcesSummary",
    getMonitoringAlerts: "getMonitoringAlerts",
    suppressMonitoringAlert: "suppressMonitoringAlert",
    clearMonitoringAlertSuppression: "clearMonitoringAlertSuppression",
    getMediaSourcesSummary: "getMediaSourcesSummary",
    getSourceRuns: "getSourceRuns",
    getRunPipelineItems: "getRunPipelineItems",
};

export const ENDPOINT_METHODS = {
    getMediaSummary: "GET",
    getAllSourcesSummary: "GET",
    getMonitoringAlerts: "GET",
    suppressMonitoringAlert: "POST",
    clearMonitoringAlertSuppression: "DELETE",
    getMediaSourcesSummary: "GET",
    getSourceRuns: "GET",
    getRunPipelineItems: "GET",
};

export const QUERYKEYS = ENDPOINTS;

function getMediaId(parameters) {
    if (!parameters) return null;
    return parameters.media_id ?? parameters.mediaId ?? parameters.id ?? null;
}

function getSourceId(parameters) {
    if (!parameters) return null;
    return parameters.source_id ?? parameters.sourceId ?? null;
}

function getRunId(parameters) {
    if (!parameters) return null;
    return parameters.run_id ?? parameters.runId ?? parameters.sourceIngestionRunId ?? null;
}

function getAlertId(parameters) {
    if (!parameters) return null;
    return parameters.alert_id ?? parameters.alertId ?? null;
}

export const createEndpointUrl = function ({ endpoint, parameters }) {
    if (DEBUG) console.log(`createEndpointUrl: ${endpoint}`);

    switch (endpoint) {
        case ENDPOINTS.getMediaSummary:
            return `${ENDPOINT_PATHS.monitoring}/media-summary`;

        case ENDPOINTS.getAllSourcesSummary:
            return `${ENDPOINT_PATHS.monitoring}/sources-summary`;

        case ENDPOINTS.getMonitoringAlerts:
            return `${ENDPOINT_PATHS.monitoring}/alerts`;

        case ENDPOINTS.suppressMonitoringAlert:
        case ENDPOINTS.clearMonitoringAlertSuppression: {
            const alertId = getAlertId(parameters);
            if (!alertId) {
                throw new Error(`Required parameter 'alert_id' is missing for ${endpoint}`);
            }
            return `${ENDPOINT_PATHS.monitoring}/alerts/${encodeURIComponent(alertId)}/suppress`;
        }

        case ENDPOINTS.getMediaSourcesSummary: {
            const mediaId = getMediaId(parameters);
            if (!mediaId) {
                throw new Error(`Required parameter 'media_id' is missing for ${endpoint}`);
            }
            return `${ENDPOINT_PATHS.monitoring}/${encodeURIComponent(mediaId)}/summary`;
        }

        case ENDPOINTS.getSourceRuns: {
            const sourceId = getSourceId(parameters);
            if (!sourceId) {
                throw new Error(`Required parameter 'source_id' is missing for ${endpoint}`);
            }
            const days = parameters?.days ?? 14;
            const query = toQueryString({ days });
            return `${ENDPOINT_PATHS.monitoring}/sources/${encodeURIComponent(sourceId)}/runs${query ? `?${query}` : ""}`;
        }

        case ENDPOINTS.getRunPipelineItems: {
            const runId = getRunId(parameters);
            if (!runId) {
                throw new Error(`Required parameter 'run_id' is missing for ${endpoint}`);
            }
            return `${ENDPOINT_PATHS.monitoring}/source-runs/${encodeURIComponent(runId)}/pipeline-items`;
        }

        default:
            throw new Error(`MonitoringApiConstants :: Unknown endpoint: ${endpoint}`);
    }
};
